export const ALL_PROFILE_SUPPORT_LABEL = 'stock .ALL 1.x / JJOS .ALL 4.x';
export const PGM_PROFILE_SUPPORT_LABEL = 'stock .PGM 1.x / JJOS .PGM 6.x / JJOS .PGM 8.x';

/** @typedef {{ id: string, kind: string, os: string, label: string, version: string, supported: boolean, knownVersion: string, quirks: object }} Profile */

/** @param {{ id: string, kind: string, os: string, label: string, version: string, supported: boolean, knownVersion: string, quirks?: object }} args
 *  @returns {Profile} */
function baseProfile({ id, kind, os, label, version, supported, knownVersion, quirks = {} }) {
  return {
    id,
    kind,
    os,
    label,
    version,
    supported,
    knownVersion,
    quirks,
  };
}

export function detectAllProfile(version) {
  const v = (version ?? '').trim();
  if (/^MPC1000 ALL 1\./.test(v)) {
    return baseProfile({
      id: 'stock-all-1.x',
      kind: 'all',
      os: 'stock',
      label: 'Stock Akai OS .ALL 1.x',
      version: v,
      supported: true,
      knownVersion: 'MPC1000 ALL 1.00',
      quirks: {
        inferAllZeroTrackMixerDefaults: true,
      },
    });
  }
  if (/^MPC1000 ALL 4\./.test(v)) {
    return baseProfile({
      id: 'jjos-all-4.x',
      kind: 'all',
      os: 'jjos',
      label: 'JJOS .ALL 4.x',
      version: v,
      supported: true,
      knownVersion: 'MPC1000 ALL 4.50',
      quirks: {
        inferAllZeroTrackMixerDefaults: false,
      },
    });
  }
  return baseProfile({
    id: v.startsWith('MPC1000 ALL') ? 'mpc1000-all-unknown' : 'unknown-all',
    kind: 'all',
    os: 'unknown',
    label: v.startsWith('MPC1000 ALL') ? 'Unknown MPC1000 .ALL' : 'Unknown .ALL',
    version: v,
    supported: false,
    knownVersion: ALL_PROFILE_SUPPORT_LABEL,
    quirks: {
      inferAllZeroTrackMixerDefaults: false,
    },
  });
}

export function detectPgmProfile(version) {
  const v = (version ?? '').trim();
  if (/^MPC1000 PGM 1\./.test(v)) {
    return baseProfile({
      id: 'stock-pgm-1.x',
      kind: 'pgm',
      os: 'stock',
      label: 'Stock Akai OS .PGM 1.x',
      version: v,
      supported: true,
      knownVersion: 'MPC1000 PGM 1.00',
    });
  }
  if (/^MPC1000 PGM 8\./.test(v)) {
    return baseProfile({
      id: 'jjos-pgm-8.x',
      kind: 'pgm',
      os: 'jjos',
      label: 'JJOS .PGM 8.x',
      version: v,
      supported: true,
      knownVersion: 'MPC1000 PGM 8.00',
    });
  }
  if (/^MPC1000 PGM 6\./.test(v)) {
    return baseProfile({
      id: 'jjos-pgm-6.x',
      kind: 'pgm',
      os: 'jjos',
      label: 'JJOS .PGM 6.x',
      version: v,
      supported: true,
      knownVersion: 'MPC1000 PGM 6.00',
    });
  }
  return baseProfile({
    id: v.startsWith('MPC1000 PGM') ? 'mpc1000-pgm-unknown' : 'unknown-pgm',
    kind: 'pgm',
    os: 'unknown',
    label: v.startsWith('MPC1000 PGM') ? 'Unknown MPC1000 .PGM' : 'Unknown .PGM',
    version: v,
    supported: false,
    knownVersion: PGM_PROFILE_SUPPORT_LABEL,
  });
}
